<template>
	<div class="preview">
		<header class="preview__header">
			<button class="preview__back-button"></button>
			{{ title }}
		</header>
		<ul class="preview__list">
			<li
				class="preview__list__item"
				v-for="(item, idx) in productList"
				:key="idx"
			>
				<div
					class="preview__list__item__product product"
					ref="productCard"
				>
					<div
						v-if="item.doc.weeklyWinnerCount"
						style="margin: auto 10px"
					>
						{{ item.doc.weeklyWinnerCount }}주
						<p
							v-if="item.doc.isNew"
							style="text-align: center; color: red"
						>
							N
						</p>
					</div>

					<img class="product__img" :src="item.imageUrl" />
					<p class="product__ranking">{{ item.ranking }}</p>
					<div class="product__product">
						<ul class="product__category-box">
							<li
								class="product__category"
								v-if="item.category.secondCategoryText"
							>
								#{{ item.category.secondCategoryText }}
							</li>
							<li
								class="product__category"
								v-if="item.brand.brandTitle"
							>
								#{{ item.brand.name }}
							</li>
						</ul>
						<p class="product__name">{{ item.productTitle }}</p>
						<div class="product__info-box">
							<p class="product__rating-avg">
								{{ item.ratingAvg }}
							</p>
							<p class="product__review-count">
								(리뷰 {{ item.reviewCount | currency }})
							</p>
						</div>
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>
<script>
	import { mapState } from 'vuex';

	export default {
		name: 'CollectionPreview',
		data() {
			return {
				offset: 0,
				limit: 20,
				productList: [],
				lastOffset: 0,
			};
		},
		computed: {
			...mapState({
				title: state => state.modal.params.title,
				code: state => state.modal.params.code,
			}),
		},
		mounted() {
			this.getList();
		},
		methods: {
			getPercent(total, numerator) {
				return (
					(numerator ? Math.floor((numerator / total) * 100) : 0) +
					'%'
				);
			},
			setObserver() {
				const lastIdx = this.productList.length - 1;
				this.$refs.productCard[lastIdx].observer =
					new IntersectionObserver(changes => {
						changes.forEach(change => {
							if (change.intersectionRatio > 0) {
								this.getList();
								this.$refs.productCard[
									lastIdx
								].observer.disconnect();
							}
						});
					});
				this.$refs.productCard[lastIdx].observer.observe(
					this.$refs.productCard[lastIdx]
				);
			},
			async getList() {
				if (this.lastOffset < this.offset) return;
				const params = {
					offset: this.offset,
					limit: this.limit,
				};
				const { data } = await this.$axiosAdmin2.get(
					`/v3/api/collection/${this.code}/product/list`,
					{ params }
				);
				this.lastOffset = data.pageTotal * data.limit;
				this.offset += this.limit;
				this.productList = [
					...this.productList,
					...data.data.map(item => {
						item.product.ranking = item.ranking;
						item.product.doc = item.doc || {};
						return item.product;
					}),
				];
				this.$nextTick(() => {
					this.setObserver();
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.preview {
		width: 377px;
		margin: 0 auto;
		border: solid 1px #f0f1f5;
	}

	.preview__header {
		height: 56px;
		padding: 16px;
		line-height: 24px;
		text-align: center;
		color: black;
		font-size: 16px;
		font-weight: 700;
	}

	.preview__back-button {
		width: 24px;
		height: 24px;
		background: no-repeat center/24px url('/static/img/icon/back.png');
		float: left;
	}

	.preview__list {
		padding: 0 16px;
	}

	.preview__list__item {
		border-bottom: solid 1px #f0f1f5;
	}

	.preview__list__item__product {
		display: flex;
		width: 100%;
		padding: 12px 0 15px;
	}

	.product__img {
		display: block;
		width: 52px;
		height: 52px;
		margin-top: 4px;
		margin-right: 15px;
		border-radius: 4px;
		border: 1px solid #f6f7fa;
	}

	.product__ranking {
		margin-top: 2px;
		margin-right: 14px;
		line-height: 22px;
		font-size: 18px;
		font-weight: 700;
	}

	.product__product {
		overflow: hidden;
	}

	.product__category-box {
		display: flex;
		margin-left: 1px;
	}

	.product__category {
		overflow: hidden;
		display: block;
		height: 14px;
		margin-right: 6px;
		background: #f6f7fa;
		padding: 0 6px;
		border-radius: 4px;
		line-height: 14px;
		color: #8b8b8b;
		font-size: 10px;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.product__name {
		overflow: hidden;
		display: block;
		margin-top: 5px;
		margin-bottom: 2px;
		white-space: nowrap;
		text-overflow: ellipsis;
		line-height: 20px;
		font-size: 14px;
	}

	.product__info-box {
		display: flex;

		&:before {
			content: '';
			display: block;
			width: 14px;
			height: 14px;
			margin-top: 2px;
			background: no-repeat center / 14px
				url('/static/img/icon/star2.png');
		}
	}

	.product__rating-avg {
		margin-top: 2px;
		margin-right: 4px;
		line-height: 14px;
		font-size: 12px;
	}

	.product__review-count {
		line-height: 14px;
		font-size: 10px;
	}
</style>
